import React from 'react';

type TagVariant = 'default' | 'accent';

interface TagProps {
  children: React.ReactNode;
  variant?: TagVariant;
  /** Use on cards, where the pill needs to read against an elevated surface. */
  onSurface?: boolean;
}

const Tag: React.FC<TagProps> = ({ children, variant = 'default', onSurface = false }) => {
  const base =
    'inline-flex items-center px-3 py-1 text-sm rounded-full border transition-colors duration-200';

  const styles =
    variant === 'accent'
      ? 'text-accent bg-accent/10 border-accent/30'
      : `text-dark-text border-dark-border hover:border-dark-border-strong hover:text-dark-heading ${
          onSurface ? 'bg-dark-bg' : 'bg-dark-surface'
        }`;

  return <span className={`${base} ${styles}`}>{children}</span>;
};

export default Tag;
